import { BaseViewModel } from "@iot-platform/core";
import { UserGetAllResumeUseCase, Users } from "@iot-platform/user";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class AssignedSpatialLevelsViewmodel extends BaseViewModel {
    @observable
    usersResume: Users = Users.empty();

    @observable
    initialLoading = true;

    @observable
    usersLoading = true;

    constructor(
        @inject(UserGetAllResumeUseCase)
        private readonly userGetAllResumeUseCase: UserGetAllResumeUseCase,
    ) {
        super();
        makeObservable(this);
    }

    @action
    override async didMount(): Promise<void> {
        await this.initViewData();
    }

    async initViewData(): Promise<void> {
        await this.fetchUsersResume();

        runInAction(() => {
            this.initialLoading = false;
        });
    }

    @action
    private async fetchUsersResume(): Promise<void> {
        this.usersResume = await this.userGetAllResumeUseCase.execute();
        this.usersLoading = false;
    }

    @action
    async reloadUsersResume(): Promise<void> {
        await this.fetchUsersResume();
    }
}
